import { css } from 'lit';

// these styles can be imported from any component
// for an example of how to use this, check /pages/app-about/app-about.ts
export const appIndexStyles = css`
  :host {
    display: block;
    min-height: 100%;
  }

  #smooth-wrapper,
  #smooth-content {
    min-height: 100%;
  }

  #smooth-content > wa-page {
    min-height: 100vh;
  }

  wa-page {
    min-height: 100%;
  }

  wa-page::part(header) {
    align-items: center;
    display: flex;
  }

  a {
    border-radius: 999px;
    color: var(--app-color-link);
    padding: 0.25em 0.5em;
    transition: background-color 150ms ease, color 150ms ease;
  }

  a:visited {
    color: var(--app-color-link-visited);
  }

  a:hover {
    background-color: var(--app-link-hover-background);
  }

  a:visited:hover {
    background-color: var(--app-link-visited-hover-background);
  }

  #network-status {
    align-items: center;
    background: var(--app-color-surface);
    border: 3px solid var(--app-color-focus);
    border-radius: var(--wa-border-radius-m);
    box-shadow: var(--wa-shadow-l);
    box-sizing: border-box;
    color: var(--app-color-text);
    display: flex;
    font-weight: 700;
    gap: var(--wa-space-s);
    inset-inline: 50% auto;
    justify-content: center;
    max-width: min(42rem, calc(100vw - 2rem));
    padding: var(--wa-space-s) var(--wa-space-m);
    position: fixed;
    text-align: center;
    top: calc(56px + env(safe-area-inset-top) + 10px);
    transform: translateX(-50%);
    z-index: 1100;
  }

  #network-status[hidden] {
    display: none;
  }

  #network-status[data-severity='alert'] {
    border-width: 5px;
  }

  /* This button is slotted through app-header, so style its Web Awesome part here. */
  wa-button[slot='navigation-toggle']::part(base) {
    color: gray;
  }

  :host-context(.wa-dark) wa-button[slot='navigation-toggle']::part(base) {
    color: #000;
  }

  :host-context(.wa-light) wa-button[slot='navigation-toggle']::part(base) {
    color: #fff;
  }

  /* These links live in app-index's Shadow DOM, so global.css cannot style them. */
  [slot='navigation'] a {
    display: inline-flex;
    min-height: 44px;
    align-items: center;
    font-size: 24px;
    font-weight: 700;
    text-underline-offset: 5px;
  }

  [slot='navigation'] a[aria-current='page'] {
    font-weight: 800;
    text-decoration-thickness: 3px;
  }

  main {
    /* wa-page already supplies the 10px header gap; adding more here doubles it. */
    padding-block-start: 0;
    padding-bottom: var(--wa-space-m);
    padding-inline: var(--wa-space-m);
  }
  wa-page::part(main-content) {
    padding: 10px 0 0;
  }

  wa-page::part(menu) {
    overflow: visible;
    max-height: none;
  }

  .mobile-bottom-nav {
    display: none;
  }

  @media (max-width: 768px) {
    /* The bottom nav replaces the drawer trigger on small touch screens. */
    wa-button[slot='navigation-toggle'] {
      display: none;
    }

    .mobile-bottom-nav {
      align-items: center;
      background: var(--wa-color-surface-default, #fff);
      border-top: 1px solid var(--wa-color-border-default, #ccc);
      bottom: 0;
      box-sizing: content-box;
      display: flex;
      height: 60px;
      justify-content: space-around;
      left: 0;
      padding-bottom: env(safe-area-inset-bottom);
      position: fixed;
      right: 0;
      z-index: 1000;
    }

    .mobile-bottom-nav a {
      align-items: center;
      color: var(--app-color-text);
      display: flex;
      flex: 1 1 0;
      flex-direction: column;
      font-size: 0.75rem;
      font-weight: 700;
      gap: 2px;
      justify-content: center;
      min-height: 44px;
      text-decoration: none;
    }

    .mobile-bottom-nav wa-icon {
      font-size: 1.25rem;
    }

    .mobile-bottom-nav a[aria-current='page'] {
      color: var(--app-color-link);
      text-decoration: underline;
      text-decoration-thickness: 3px;
      text-underline-offset: 4px;
    }

    .mobile-bottom-nav a:visited {
      color: var(--app-color-link-visited);
    }

    .mobile-bottom-nav a[aria-current='page'] {
      color: var(--app-color-link);
    }

    .mobile-bottom-nav a:focus-visible {
      outline: var(--app-focus-ring);
      outline-offset: -4px;
    }

    #routed-content {
      padding-bottom: calc(70px + env(safe-area-inset-bottom));
    }

    app-footer {
      margin-bottom: calc(60px + env(safe-area-inset-bottom));
    }
  }
`;
